const language_selected = {
    english: {
        header_text: "Please Sign Below",
        header2_text: "Dots,lines or random shapes wont be accepted",
        breakline_text: "or",
        upload_text: "Upload Signature on plain paper",
        clear_text: "Erase all",
        success: "Signature captured successfully",

        btn_text: "Continue ⚡",
        pop_up: "Signature went out of the box! Please stay within the area.",
        invalid_sign: "Not a valid sign",
        max_file_size: "Max File Size: 20 MB",
        draw_or_upload: "Please either draw a signature or upload an image.",

        file_size_exceed: "File size must not exceed 20 MB.",
        pdf_not_supported: "PDF upload is not supported. Please upload an image file.",
        jfif_not_supported: "Only JPG, JPEG, and PNG files are allowed. JFIF files are not supported.",
        server_or_invalid_file: "Server error or invalid file. Please try again or upload a different file.",
        server_error_simple: "Something went wrong with the server."
        , file_size_min: "File size must be at least 10 KB.",
        file_type_not_accepted: "This file type is not accepted.",
        valid_image_required: "Please select a valid image (JPEG, PNG, GIF, or BMP).",
        remarks: {
            white_background_required: "Please capture/upload signature on plain, white background."
        }

    },
    hindi: {
        header_text: "कृपया नीचे हस्ताक्षर करें",
        header2_text: "बिंदु, रेखाएँ या किसी भी प्रकार के यादृच्छिक चिन्ह स्वीकार नहीं किए जाएंगे।",
        breakline_text: "या",
        upload_text: "साधारण कागज़ पर हस्ताक्षर अपलोड करें",
        clear_text: "साफ़ करें",
        success: "हस्ताक्षर सफलतापूर्वक कैप्चर हो गया",

        btn_text: "जारी रखें ⚡",
        pop_up: "हस्ताक्षर बॉक्स से बाहर चला गया! कृपया क्षेत्र के भीतर रहें।",
        invalid_sign: "अमान्य हस्ताक्षर",
        max_file_size: "अधिकतम फ़ाइल आकार: 20 MB",
        draw_or_upload: "कृपया या तो हस्ताक्षर बनाएं या एक छवि अपलोड करें।",

        file_size_exceed: "फ़ाइल का आकार 20 MB से अधिक नहीं होना चाहिए।",
        pdf_not_supported: "PDF अपलोड समर्थित नहीं है। कृपया एक छवि फ़ाइल अपलोड करें।",
        jfif_not_supported: "केवल JPG, JPEG और PNG फ़ाइलें ही अनुमति हैं। JFIF फ़ाइलें समर्थित नहीं हैं.",
        server_or_invalid_file: "सर्वर त्रुटि या अमान्य फ़ाइल। कृपया पुनः प्रयास करें या एक अलग फ़ाइल अपलोड करें।",
        server_error_simple: "सर्वर के साथ कुछ गलत हो गया।",
        file_size_min: "फ़ाइल का आकार कम से कम 10 KB होना चाहिए।",
        file_type_not_accepted: "इस फ़ाइल प्रकार को स्वीकार नहीं किया जाता है।",
        valid_image_required: "कृपया एक मान्य छवि चुनें (JPEG, PNG, GIF, या BMP)।",
        remarks: {
            white_background_required: "कृपया साधारण, सफेद पृष्ठभूमि पर हस्ताक्षर कैप्चर/अपलोड करें।"
        }


    },
    marathi: {
        header_text: "पॅन नुसार बॉक्समध्ये सही करा",
        breakline_text: "किंवा",
        upload_text: "साधारण कागदावर सही अपलोड करा",
        clear_text: "साफ करा",
        success: "सही यशस्वीरित्या कॅप्चर केली गेली आहे",

        btn_text: "सुरू ठेवा",
        pop_up: "सही बॉक्सच्या बाहेर गेली! कृपया क्षेत्राच्या आत रहा.",
        invalid_sign: "अवैध सही",
        max_file_size: "जास्तीत जास्त फाईल आकार: 20 MB",
        draw_or_upload: "कृपया सही काढा किंवा प्रतिमा अपलोड करा.",

        file_size_exceed: "फाईलचा आकार 20 MB पेक्षा जास्त नसावा.",
        pdf_not_supported: "PDF अपलोड समर्थित नाही. कृपया प्रतिमा फाईल अपलोड करा.",
        jfif_not_supported: "फक्त JPG, JPEG आणि PNG फाइल्सच परवानगी आहेत. JFIF फाइल्स समर्थित नाहीत.",
        server_or_invalid_file: "सर्व्हर त्रुटी किंवा अवैध फाईल. कृपया पुन्हा प्रयत्न करा किंवा वेगळी फाईल अपलोड करा.",
        server_error_simple: "सर्व्हरमध्ये काहीतरी चूक झाली आहे.",
        file_size_min: "फाईलचा आकार किमान 10 KB असावा.",
        file_type_not_accepted: "हा फाईल प्रकार स्वीकारला जात नाही.",
        valid_image_required: "कृपया वैध प्रतिमा निवडा (JPEG, PNG, GIF, किंवा BMP).",
        remarks: {
            white_background_required: "कृपया साधी, पांढऱ्या पार्श्वभूमीवर सही कॅप्चर/अपलोड करा."
        }
    },
    gujarati: {
        header_text: "પેન કાર્ડ મુજબ બોક્સમાં સહી કરો",
        breakline_text: "અથવા",
        upload_text: "સાદા સફેદ કાગળ પરની સહી અપલોડ કરો",
        clear_text: "સાફ કરો",
        success: "સહી સફળતાપૂર્વક સેવ થઈ ગઈ છે",

        btn_text: "આગળ વધો",
        pop_up: "સહી બોક્સની બહાર ગઈ છે. કૃપા કરીને બોક્સની અંદર સહી કરો.",
        invalid_sign: "માન્ય સહી નથી",
        max_file_size: "મહત્તમ ફાઇલ સાઇઝ: 20 MB",
        draw_or_upload: "કૃપા કરીને સહી દોરો અથવા તેની તસવીર અપલોડ કરો.",

        file_size_exceed: "ફાઇલ સાઇઝ 20 MB કરતાં વધુ ન હોવી જોઈએ.",
        pdf_not_supported: "PDF ફાઇલ માન્ય નથી. કૃપા કરીને ઇમેજ ફાઇલ અપલોડ કરો.",
        jfif_not_supported: "માત્ર JPG, JPEG અને PNG ફાઇલ જ માન્ય છે. JFIF માન્ય નથી.",
        server_or_invalid_file: "સર્વર સમસ્યા છે અથવા ફાઇલ ખોટી છે. ફરી પ્રયાસ કરો.",
        server_error_simple: "સર્વરમાં કોઈ સમસ્યા આવી છે.",
        file_size_min: "ફાઇલ સાઇઝ ઓછામાં ઓછું 10 KB હોવી જોઈએ.",
        file_type_not_accepted: "આ પ્રકારની ફાઇલ માન્ય નથી.",
        valid_image_required: "કૃપા કરીને માન્ય ઇમેજ પસંદ કરો (JPEG, PNG, GIF અથવા BMP).",
        remarks: {
            white_background_required: "કૃપા કરીને સાદા સફેદ પૃષ્ઠભૂમિ પર સહી કરો અથવા અપલોડ કરો."
        }
    }

};

module.exports = { language_selected };
